/**
 * LanguageSwitcher Component
 * Compact text buttons to switch UI language
 * Uses text labels instead of flag emojis (flags don't render on Windows)
 * When designColors prop is provided, uses inline styles (custom designs).
 * When designColors is absent, uses isDarkMode Tailwind classes (classic design).
 */
import React from 'react';
import { useTranslation } from './LanguageContext';

const LanguageSwitcher = ({ isDarkMode, size = 'sm', designColors }) => {
  const { lang, setLang, LANGUAGES } = useTranslation();

  return (
    <div className="flex flex-wrap items-center justify-center gap-0.5 sm:gap-1">
      {LANGUAGES.map((language) => {
        const isActive = lang === language.code;
        if (designColors) {
          return (
            <button
              key={language.code}
              onClick={() => setLang(language.code)}
              className={`rounded-lg font-medium transition-all ${
                size === 'sm' ? 'text-[10px] px-1.5 py-0.5 sm:text-xs sm:px-2 sm:py-1' : 'text-sm px-2.5 py-1.5'
              }`}
              style={isActive
                ? { backgroundColor: designColors.activeBg, color: '#ffffff', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }
                : { color: designColors.textColor }}
              title={language.name}
            >
              {language.label}
            </button>
          );
        }
        return (
          <button
            key={language.code}
            onClick={() => setLang(language.code)}
            className={`rounded-lg font-medium transition-all ${
              size === 'sm' ? 'text-[10px] px-1.5 py-0.5 sm:text-xs sm:px-2 sm:py-1' : 'text-sm px-2.5 py-1.5'
            } ${
              isActive
                ? 'bg-blue-600 text-white shadow-sm'
                : isDarkMode
                  ? 'text-gray-400 hover:bg-gray-700 hover:text-gray-200'
                  : 'text-gray-500 hover:bg-gray-100 hover:text-gray-700'
            }`}
            title={language.name}
          >
            {language.label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
